export default __webpack_public_path__ + "static/media/cntr-tracking-rq-12-blue.b6098c9a.svg";